import {React} from '@api'

export * from './CatalogItemsPanel'
export * from './CardView'

export const CatalogDataGridView = React.lazy(() => import( /* webpackChunkName: DataGrid */'./DataGrid/DataGrid').then(m => ({default: m.DataGrid})))
// export const CatalogGroupDataGridView = React.lazy(() => import( /* webpackChunkName: DataGrid */'./DataGrid/GroupDataGrid').then(m => ({default: m.GroupDataGrid})))
export const CatalogDataGridRoot = React.lazy(() => import( /* webpackChunkName: DataGrid */'./DataGrid/DataGridRoot').then(m => ({default: m.DataGridRoot})))

export * from './DataGrid/DataGridStore'
//export const CatalogItemsTableView = React.lazy(() => import(/* webpackChunkName: "TableView" */ './TableView').then(m => ({default: m.CatalogItemsTableView})))
export const CatalogReportView = React.lazy(() => import(/* webpackChunkName: "ReportView" */ './ReportView').then(m => ({default: m.CatalogReportView})))





// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_CatalogItems/index.ts